import type { LocalizedSlugMap } from '~/types/cms';

const LOCATION_ROUTE_PREFIX = 'locations-slug';
const LOCATION_PATH_PATTERN = /^(\/en)?\/(locaties|locations)\/[^/]+/;

function isLocationPage(path: string, routeName: string | symbol | null | undefined): boolean {
    if (LOCATION_PATH_PATTERN.test(path)) {
        return true;
    }

    return String(routeName ?? '').startsWith(LOCATION_ROUTE_PREFIX);
}

function buildLocationLocalePath(localeCode: string, slug: string): string {
    const segment = localeCode === 'nl' ? 'locaties' : 'locations';
    const prefix = localeCode === 'nl' ? '' : `/${localeCode}`;

    return `${prefix}/${segment}/${slug}`;
}

export function useAppSwitchLocalePath() {
    const route = useRoute();
    const switchLocalePath = useSwitchLocalePath();
    const locationI18nParams = useLocationI18nParams();

    return (localeCode: string) => {
        if (!isLocationPage(route.path, route.name)) {
            return switchLocalePath(localeCode as 'nl' | 'en');
        }

        const i18nParams = locationI18nParams.value ?? (route.meta.nuxtI18n as LocalizedSlugMap | undefined);
        const slug = i18nParams?.[localeCode]?.slug;

        if (typeof slug === 'string' && slug.length > 0) {
            return buildLocationLocalePath(localeCode, slug);
        }

        return switchLocalePath(localeCode as 'nl' | 'en');
    };
}
